module.exports = "<button class=nn-base-button ng-class=className() type=button><div class=nn-base-button__icon ng-if=icon><nn-base-svg icon=icon></nn-base-svg></div><div ng-transclude></div></button>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-base-components/nn-base-button/nn-base-button.button.directive.html
// module id = 951
// module chunks = 0